<template>
  <div class="form-group">
    <label :for="exampleFormControlTextarea1">
      <slot />
    </label>
    <textarea
      class="form-control"
      :class="{ 'input-error': hassError }"
      :rows=rows
      :id="exampleFormControlTextarea1"
      :value="modelValue"
      :placeholder="placeholder"
      @input="onInput"
      :maxlength="maxLength"
      :disabled="read"
    ></textarea>
  </div>
</template>

<script>

export default {
  name: "argon-textarea",
  props: {
    id: String,
    placeholder: String,
    modelValue: {
      type: String,
      default: "",
    },
    rows:{
      type: Number,
      default:5
    },
    read:{
      type:Boolean,
      default:false
    },
    maxLength:{
      type:Number,
      default:5000
    },
    hassError:{
      type:Boolean,
      default:false
    }
  },
  emits:["update:modelValue"],
  methods: {
    onInput(e){
      this.$emit("update:modelValue",e.target.value)
    },
  }
};
</script>
<style scoped>
  .input-error {
  border: 2px solid red;
  /* Prevent the user from typing more than the max length */
  /* If you want to strictly prevent typing after max limit, you'll need a Watcher (see below) */
}
</style>